"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = shouldSpeakIncomingActivity;

var _startSpeakingActivity = require("../actions/startSpeakingActivity");

var _stopSpeakingActivity = require("../actions/stopSpeakingActivity");

function shouldSpeakIncomingActivity() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type;

  switch (type) {
    case _startSpeakingActivity.START_SPEAKING_ACTIVITY:
      state = true;
      break;

    case _stopSpeakingActivity.STOP_SPEAKING_ACTIVITY:
      state = false;
      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzaG91bGRTcGVha0luY29taW5nQWN0aXZpdHkiLCJzdGF0ZSIsInR5cGUiLCJTVEFSVF9TUEVBS0lOR19BQ1RJVklUWSIsIlNUT1BfU1BFQUtJTkdfQUNUSVZJVFkiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcmVkdWNlcnMvc2hvdWxkU3BlYWtJbmNvbWluZ0FjdGl2aXR5LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFNUQVJUX1NQRUFLSU5HX0FDVElWSVRZIH0gZnJvbSAnLi4vYWN0aW9ucy9zdGFydFNwZWFraW5nQWN0aXZpdHknO1xuaW1wb3J0IHsgU1RPUF9TUEVBS0lOR19BQ1RJVklUWSB9IGZyb20gJy4uL2FjdGlvbnMvc3RvcFNwZWFraW5nQWN0aXZpdHknO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzaG91bGRTcGVha0luY29taW5nQWN0aXZpdHkoc3RhdGUgPSBmYWxzZSwgeyB0eXBlIH0pIHtcbiAgc3dpdGNoICh0eXBlKSB7XG4gICAgY2FzZSBTVEFSVF9TUEVBS0lOR19BQ1RJVklUWTpcbiAgICAgIHN0YXRlID0gdHJ1ZTtcbiAgICAgIGJyZWFrO1xuXG4gICAgY2FzZSBTVE9QX1NQRUFLSU5HX0FDVElWSVRZOlxuICAgICAgc3RhdGUgPSBmYWxzZTtcbiAgICAgIGJyZWFrO1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgcmV0dXJuIHN0YXRlO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7O0FBRWUsU0FBU0EsMkJBQVQsR0FBOEQ7RUFBQSxJQUF6QkMsS0FBeUIsdUVBQWpCLEtBQWlCOztFQUFBO0VBQUEsSUFBUkMsSUFBUSxRQUFSQSxJQUFROztFQUMzRSxRQUFRQSxJQUFSO0lBQ0UsS0FBS0MsOENBQUw7TUFDRUYsS0FBSyxHQUFHLElBQVI7TUFDQTs7SUFFRixLQUFLRyw0Q0FBTDtNQUNFSCxLQUFLLEdBQUcsS0FBUjtNQUNBOztJQUVGO01BQ0U7RUFWSjs7RUFhQSxPQUFPQSxLQUFQO0FBQ0QifQ==